import Vuelidate from 'vuelidate';
import VueRouter from 'vue-router';
import Vuex from 'vuex';
import { redirectToHomeWhenInactive } from 'shared_js/toggle-feature-handler';
import governmentRevenueApi from 'shared/api/government-revenue/public';
import agenliteApi from 'shared/api/agenlite/exclusive';
import neoApi from 'shared/api/neo';
import invoiceApi from 'shared/api/invoice';
import subsidyApi from 'shared/api/subsidy/public';
import voucherApi from 'shared/api/voucher/public';

import routes from './config/routes';
import storeConfig from './store';
import MainApp from './MainApp';

const APP_ID_SELECTOR = '#app';

const router = new VueRouter({
  routes,
  mode: 'history',
  base: '/bl/bukapajak',
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) return savedPosition;
    return { x: 0, y: 0 };
  },
});

const store = new Vuex.Store({ ...storeConfig });

Vue.use(Vuelidate);
Vue.use(VueRouter);
Vue.prototype.$api = {
  ...agenliteApi,
  ...governmentRevenueApi,
  ...invoiceApi,
  ...voucherApi,
  ...subsidyApi,
  ...neoApi.endpoints(),
  abortRequestGovernmentRevenueApi: governmentRevenueApi.abortRequest,
};

const toggleEl = document.getElementById('toggle-feature');
const toggleVal = toggleEl.innerText;

// Redirect to home if toggle feature is off
redirectToHomeWhenInactive(toggleVal, 'government-revenue');

if (toggleVal === 'true') {
  const app = new Vue({
    store,
    router,
    components: { MainApp },
    template: `<MainApp/>`,
  });

  app.$mount(APP_ID_SELECTOR);
}
